import {WIDGET_SERVER} from "~/chat/ts/CommonConstants";

export default class ChatHeaderTile {
    public static getUrl(tileName: string) {
        return `${WIDGET_SERVER}/cabinet/assets/images/chat/headerTiles/${tileName}.svg`;
    }
}